import { copy as membershipCopy } from '~/funnels/membership/copy';
import { MembershipScreenMap } from '~/machines/membership-funnel/screen-map';
import { ScreenMapCopy } from '~/machines/utils/types';
import { BillingCopy, BillingContext } from '~/screens/billing';

export const copy: ScreenMapCopy<MembershipScreenMap> = {
  ...membershipCopy,
  billing: {
    payment: (context: BillingContext): Partial<BillingCopy> => ({
      ...membershipCopy.billing,
      title: 'Set up autopay.',
      description: `Arcadia will use the payment method you link now to automatically pay your ${context.utility.displayName} bill every month.`,
      learnMoreModal: undefined,
    }),
  },
};
